export default {
  routeNotFound: 'Gespeicherte URL wurde nicht gefunden',
};
